import React from "react";
import Moment from "react-moment";
import { Modal } from "react-bootstrap";
import { getWfPhasesColor } from "../services/appService";

const TaskHistory = (props) => {
  const {
    historyAppShowHide,
    handlehistoryAppModalShowHide,
    selectedObj: task,
    doneTasks,
    taskPhases = [],
  } = props;

  const themeClass = task
    ? (getWfPhasesColor(task.wfPhase) || "btn-default").replace("btn-", "theme-")
    : "theme-default";

  const getPhaseBadgeColorClass = (phase) => getWfPhasesColor(phase) || "btn-default";

  const getSortValue = (value) => {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : Number.MAX_SAFE_INTEGER;
  };

  const getDisplayValue = (value) => {
    if (value === 0) return 0;
    return value || "-";
  };

  const getTaskStateLabel = (value) => {
    switch (Number(value)) {
      case 0:
      case 1:
        return "Not Started";
      case 2:
        return "In Process";
      case 3:
        return "Suspended";
      case 4:
        return "Completed";
      default:
        return getDisplayValue(value);
    }
  };

  const getItemTypeLabel = (value) => {
    switch (Number(value)) {
      case 1:
        return "Person Based Task";
      case 3:
        return "Conditional Task";
      case 4:
        return "Automated Task";
      default:
        return getDisplayValue(value);
    }
  };

  const shouldShowPerformer = (item) => Number(item?.itemType) === 1;

  const phaseOrder = (taskPhases || [])
    .map((phase, index) => ({
      name: phase?.wfPhase || phase?.phase || phase,
      order: getSortValue(phase?.orderNumber),
      index,
    }))
    .filter((phase) => phase.name)
    .sort((a, b) => a.order - b.order || a.index - b.index)
    .reduce((orderMap, phase, index) => {
      if (!orderMap.has(phase.name)) orderMap.set(phase.name, index);
      return orderMap;
    }, new Map());

  const sortedDoneTasks = [...(doneTasks || [])].sort((a, b) => {
    const phaseA = phaseOrder.has(a.wfPhase) ? phaseOrder.get(a.wfPhase) : getSortValue(a.orderNumber);
    const phaseB = phaseOrder.has(b.wfPhase) ? phaseOrder.get(b.wfPhase) : getSortValue(b.orderNumber);

    return (
      phaseA - phaseB ||
      getSortValue(a.orderNumber) - getSortValue(b.orderNumber) ||
      getSortValue(a.wiid) - getSortValue(b.wiid)
    );
  });

  if (!historyAppShowHide) return null;

  return (
    <Modal
      show={Boolean(historyAppShowHide)}
      onHide={handlehistoryAppModalShowHide}
      size="xl"
      dialogClassName={`rt-history-modal ${themeClass}`}
      centered
    >
      <style>{`
        /* Ensure the modal and backdrop are on top of sidebars/headers */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .rt-history-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .rt-history-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .rt-history-modal {
          --task-accent: #2563eb;
          --task-soft: rgba(37, 99, 235, 0.04);
          max-width: 90% !important;
          width: 1200px !important;
        }

        /* Scoped to header only */
        .rt-history-modal .modal-header {
          --header-accent: #2563eb;
          --header-soft: rgba(37, 99, 235, 0.04);
        }
        .rt-history-modal.theme-primary .modal-header { --header-accent: #3b82f6; --header-soft: #eff6ff; }
        .rt-history-modal.theme-info .modal-header { --header-accent: #06b6d4; --header-soft: #ecfeff; }
        .rt-history-modal.theme-warning .modal-header { --header-accent: #f59e0b; --header-soft: #fffbeb; }
        .rt-history-modal.theme-success .modal-header { --header-accent: #22c55e; --header-soft: #f0fdf4; }
        .rt-history-modal.theme-wf2-default .modal-header { --header-accent: #eab308; --header-soft: #fef9c3; }
        .rt-history-modal.theme-wf3-default .modal-header { --header-accent: #10b981; --header-soft: #ecfdf5; }
        .rt-history-modal.theme-wf4-default .modal-header { --header-accent: #ef4444; --header-soft: #fef2f2; }
        .rt-history-modal.theme-wf5-default .modal-header { --header-accent: #f97316; --header-soft: #fff7ed; }
        .rt-history-modal.theme-wf6-default .modal-header { --header-accent: #8b5cf6; --header-soft: #f5f3ff; }
        .rt-history-modal.theme-default .modal-header,
        .rt-history-modal.theme-wf-default .modal-header { --header-accent: #64748b; --header-soft: #f8fafc; }

        .rt-history-modal .modal-content {
          border-radius: 9px !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        .rt-history-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 24px 28px 20px 32px !important;
          background: linear-gradient(90deg, var(--header-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }
        .rt-history-modal .modal-header::before {
          content: "" !important;
          position: absolute !important;
          top: -1px !important;
          left: -1px !important;
          bottom: -1px !important;
          width: 5px !important;
          background: var(--header-accent) !important;
          border-radius: 12px 0 0 0 !important;
        }
        .rt-history-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 8px !important;
          width: 100% !important;
        }
        .rt-history-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 18px !important;
          width: 100% !important;
        }
        .rt-history-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }
        .rt-history-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 8px !important;
          min-width: 0 !important;
          padding-top: 4px !important;
        }
        .rt-history-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 18px !important;
          font-weight: 850 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }
        .rt-history-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 8px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: var(--header-accent) !important;
          background: #ffffff !important;
          border: 1px solid var(--header-accent) !important;
          box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
          font-size: 15px !important;
          flex-shrink: 0 !important;
        }
        .rt-history-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }
        .rt-history-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 999px !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: var(--header-soft) !important;
          color: var(--header-accent) !important;
          border: 1px solid #e2e8f0 !important;
        }
        .rt-history-modal .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 10px 12px !important;
          margin-top: 0 !important;
          padding-left: 0 !important;
          font-size: 12px !important;
          color: #64748b !important;
        }
        .rt-history-modal .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          background: #ffffff !important;
          padding: 5px 10px !important;
          border-radius: 8px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          border: 1px solid #e2e8f0 !important;
          box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
        }
        .rt-history-modal .rt-meta-chip i {
          color: var(--task-accent) !important;
          font-size: 11px !important;
        }

        /* Premium Header Close Button */
        .rt-history-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 40px !important;
          height: 40px !important;
          padding: 0 !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
          font-family: inherit !important;
        }
        .rt-history-modal .rt-action-btn:hover {
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .rt-history-modal .rt-action-btn:active {
          transform: translateY(0) !important;
        }
        .rt-history-modal .rt-action-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
          transition: color 0.2s ease !important;
        }
        .rt-history-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }

        /* Premium Modal Footer */
        .rt-history-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 16px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 8px !important;
        }
        .rt-history-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 5px !important;
          padding: 9px 20px !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          font-family: inherit !important;
        }
        .rt-history-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .rt-history-modal .wf-modal-footer-close-btn:active {
          transform: translateY(0) !important;
        }

        .rt-history-modal .modal-body {
          padding: 24px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 220px) !important;
          overflow-y: auto !important;
        }

        /* Empty State */
        @keyframes emptyFadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .wf-table-empty {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 48px 24px;
          text-align: center;
          overflow: hidden;
          background: #ffffff;
          border-radius: 12px;
          border: 1.5px solid rgba(99,102,241,0.08);
          animation: emptyFadeUp 0.35s ease both;
        }
        .wf-te-icon-wrap {
          position: relative;
          width: 72px; height: 72px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 16px;
          z-index: 1;
        }
        .wf-te-icon {
          width: 64px; height: 64px;
          border-radius: 14px;
          background: #f8fafc;
          border: 1.5px solid #e2e8f0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #94a3b8;
          position: relative;
          z-index: 2;
        }
        .wf-te-title {
          font-size: 16px;
          font-weight: 800;
          color: #1e293b;
          margin: 0 0 8px 0;
          line-height: 1.3;
        }
        .wf-te-desc {
          font-size: 13px;
          color: #64748b;
          margin: 0;
          line-height: 1.5;
        }

        /* ---- Timeline Pro UI ---- */
        .rt-history-stats-bar {
          display: flex !important;
          align-items: center !important;
          gap: 16px !important;
          flex-wrap: wrap !important;
          margin-bottom: 12px !important;
          padding: 14px 20px !important;
          background: #f8fafc !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 8px !important;
        }
        .rt-stat-item {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
        }
        .rt-stat-icon {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 30px !important;
          height: 30px !important;
          border-radius: 7px !important;
          background: var(--task-soft) !important;
          color: var(--task-accent) !important;
          font-size: 12px !important;
        }
        .rt-stat-info {
          display: flex !important;
          flex-direction: column !important;
        }
        .rt-stat-label {
          font-size: 9px !important;
          font-weight: 700 !important;
          color: #94a3b8 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
        }
        .rt-stat-value {
          font-size: 12px !important;
          font-weight: 800 !important;
          color: #1e293b !important;
        }
        .rt-stat-divider {
          width: 1px !important;
          height: 28px !important;
          background: #e2e8f0 !important;
        }

        .rt-history-timeline {
          position: relative !important;
          padding-left: 40px !important;
          margin: 0 !important;
        }
        .rt-history-timeline::before {
          content: '' !important;
          position: absolute !important;
          top: 0 !important;
          bottom: 0 !important;
          left: 19px !important;
          width: 2px !important;
          background: linear-gradient(180deg, var(--task-accent) 0%, #e2e8f0 100%) !important;
          border-radius: 2px !important;
        }

        @keyframes timelineItemIn {
          from { opacity: 0; transform: translateX(-12px); }
          to   { opacity: 1; transform: translateX(0); }
        }
        .rt-history-timeline-item {
          position: relative !important;
          margin-bottom: 12px !important;
          animation: timelineItemIn 0.35s ease both !important;
        }
        .rt-history-timeline-item:last-child {
          margin-bottom: 0 !important;
        }
        .rt-history-timeline-badge {
          position: absolute !important;
          left: -40px !important;
          top: 16px !important;
          width: 36px !important;
          height: 36px !important;
          border-radius: 50% !important;
          background: #ffffff !important;
          border: 2.5px solid var(--task-accent) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          z-index: 1 !important;
          color: var(--task-accent) !important;
          font-size: 12px !important;
          font-weight: 800 !important;
          box-shadow: 0 4px 8px rgba(37, 99, 235, 0.12) !important;
        }
        .rt-history-timeline-card {
          --phase-clr: var(--task-accent);
          --phase-bg: var(--task-soft);
          position: relative !important;
          background: #ffffff !important;
          border: 1px solid rgba(148, 163, 184, 0.26) !important;
          border-radius: 8px !important;
          padding: 0 !important;
          box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05) !important;
          transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease !important;
          overflow: hidden !important;
        }
        .rt-history-timeline-card::before {
          content: "" !important;
          position: absolute !important;
          inset: 0 auto 0 0 !important;
          width: 3px !important;
          background: linear-gradient(180deg, var(--phase-clr), rgba(255,255,255,0)) !important;
        }
        .rt-history-timeline-card:hover {
          border-color: rgba(148, 163, 184, 0.7) !important;
          box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08) !important;
          transform: translateY(-1px) !important;
        }
        .rt-history-timeline-card.btn-primary { --phase-clr: #3b82f6; --phase-bg: #eff6ff; }
        .rt-history-timeline-card.btn-info { --phase-clr: #06b6d4; --phase-bg: #ecfeff; }
        .rt-history-timeline-card.btn-warning { --phase-clr: #f59e0b; --phase-bg: #fffbeb; }
        .rt-history-timeline-card.btn-success { --phase-clr: #22c55e; --phase-bg: #f0fdf4; }
        .rt-history-timeline-card.btn-wf2-default { --phase-clr: #eab308; --phase-bg: #fef9c3; }
        .rt-history-timeline-card.btn-wf3-default { --phase-clr: #10b981; --phase-bg: #ecfdf5; }
        .rt-history-timeline-card.btn-wf4-default { --phase-clr: #ef4444; --phase-bg: #fef2f2; }
        .rt-history-timeline-card.btn-wf5-default { --phase-clr: #f97316; --phase-bg: #fff7ed; }
        .rt-history-timeline-card.btn-wf6-default { --phase-clr: #8b5cf6; --phase-bg: #f5f3ff; }
        .rt-history-timeline-card.btn-default,
        .rt-history-timeline-card.btn-wf-default { --phase-clr: #64748b; --phase-bg: #f8fafc; }
        .rt-tl-card-header {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          padding: 10px 14px 10px 16px !important;
          background: linear-gradient(90deg, var(--phase-bg) 0%, #ffffff 58%) !important;
          border-bottom: 1px solid rgba(226, 232, 240, 0.9) !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
        }
        .rt-tl-card-title-row {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          min-width: 0 !important;
          flex: 1 1 260px !important;
        }
        .rt-tl-title-mark {
          width: 32px !important;
          height: 32px !important;
          border-radius: 9px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          background: #ffffff !important;
          border: 1px solid rgba(148, 163, 184, 0.45) !important;
          color: var(--phase-clr) !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.07) !important;
          flex-shrink: 0 !important;
        }
        .rt-tl-card-title-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          min-width: 0 !important;
        }
        .rt-tl-card-name-row,
        .rt-tl-card-subline {
          display: flex !important;
          align-items: center !important;
          gap: 4px !important;
          flex-wrap: wrap !important;
        }
        .rt-tl-card-name {
          font-size: 14px !important;
          font-weight: 850 !important;
          color: #0f172a !important;
          line-height: 1.2 !important;
        }
        .rt-tl-card-id,
        .rt-tl-order-chip {
          font-size: 9.5px !important;
          font-weight: 800 !important;
          color: #64748b !important;
          background: rgba(255,255,255,0.82) !important;
          padding: 2px 7px !important;
          border-radius: 999px !important;
          border: 1px solid rgba(203, 213, 225, 0.82) !important;
          box-shadow: 0 1px 2px rgba(15,23,42,0.04) !important;
        }
        .rt-history-phase-badge {
          --phase-clr: #64748b;
          --phase-bg: #f8fafc;
          background: var(--phase-bg) !important;
          color: var(--phase-clr) !important;
          border: 1px solid var(--phase-bg) !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          padding: 3px 10px !important;
          border-radius: 999px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.03em !important;
        }
        .rt-history-phase-badge.btn-primary { --phase-clr: #3b82f6; --phase-bg: #eff6ff; }
        .rt-history-phase-badge.btn-info { --phase-clr: #06b6d4; --phase-bg: #ecfeff; }
        .rt-history-phase-badge.btn-warning { --phase-clr: #f59e0b; --phase-bg: #fffbeb; }
        .rt-history-phase-badge.btn-success { --phase-clr: #22c55e; --phase-bg: #f0fdf4; }
        .rt-history-phase-badge.btn-wf2-default { --phase-clr: #eab308; --phase-bg: #fef9c3; }
        .rt-history-phase-badge.btn-wf3-default { --phase-clr: #10b981; --phase-bg: #ecfdf5; }
        .rt-history-phase-badge.btn-wf4-default { --phase-clr: #ef4444; --phase-bg: #fef2f2; }
        .rt-history-phase-badge.btn-wf5-default { --phase-clr: #f97316; --phase-bg: #fff7ed; }
        .rt-history-phase-badge.btn-wf6-default { --phase-clr: #8b5cf6; --phase-bg: #f5f3ff; }
        .rt-history-phase-badge.btn-default,
        .rt-history-phase-badge.btn-wf-default { --phase-clr: #64748b; --phase-bg: #f8fafc; }

        .rt-tl-card-duration {
          font-size: 9.5px !important;
          font-weight: 800 !important;
          color: #2563eb !important;
          background: #e0f2fe !important;
          padding: 5px 9px !important;
          border-radius: 8px !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 5px !important;
          border: 1px solid #bfdbfe !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.08) !important;
        }
        .rt-tl-card-body {
          padding: 10px 14px 12px 16px !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 8px !important;
        }

        .rt-tl-detail-grid {
          display: grid !important;
          grid-template-columns: repeat(5, minmax(120px, 1fr)) !important;
          gap: 8px !important;
        }
        .rt-tl-detail-item,
        .rt-tl-time-block,
        .rt-tl-description {
          display: flex !important;
          align-items: center !important;
          gap: 11px !important;
          padding: 8px 10px !important;
          background: linear-gradient(180deg, #ffffff, #f8fafc) !important;
          border: 1px solid rgba(226, 232, 240, 0.95) !important;
          border-radius: 9px !important;
          min-width: 0 !important;
          box-shadow: 0 2px 7px rgba(15, 23, 42, 0.025) !important;
        }
        .rt-tl-detail-icon,
        .rt-tl-description-icon {
          width: 28px !important;
          height: 28px !important;
          border-radius: 8px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: var(--phase-clr) !important;
          background: var(--phase-bg) !important;
          border: 1px solid rgba(148, 163, 184, 0.35) !important;
          flex-shrink: 0 !important;
        }
        .rt-tl-detail-copy,
        .rt-tl-description-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 3px !important;
          min-width: 0 !important;
        }
        .rt-tl-detail-label,
        .rt-tl-description-label {
          font-size: 8.8px !important;
          font-weight: 850 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
        }
        .rt-tl-detail-value,
        .rt-tl-description-value {
          font-size: 12px !important;
          font-weight: 800 !important;
          color: #172033 !important;
          overflow-wrap: anywhere !important;
        }
        .rt-tl-description {
          align-items: flex-start !important;
        }
        .rt-tl-description-value {
          font-weight: 650 !important;
          line-height: 1.35 !important;
        }
        .rt-tl-time-block {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          padding: 8px 10px !important;
          background: #f8fafc !important;
          border: 1px solid #e8eef7 !important;
          border-radius: 9px !important;
          min-width: 0 !important;
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.85) !important;
        }
        .rt-tl-time-icon {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 28px !important;
          height: 28px !important;
          border-radius: 8px !important;
          background: #ffffff !important;
          border: 1px solid rgba(148, 163, 184, 0.35) !important;
          color: var(--phase-clr) !important;
          font-size: 12px !important;
          flex-shrink: 0 !important;
        }
        .rt-tl-time-info {
          display: flex !important;
          flex-direction: column !important;
          gap: 1px !important;
        }
        .rt-tl-time-label {
          font-size: 9px !important;
          font-weight: 700 !important;
          color: #94a3b8 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
        }
        .rt-tl-time-val {
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #334155 !important;
        }
        .rt-tl-time-arrow {
          color: #cbd5e1 !important;
          font-size: 14px !important;
          flex-shrink: 0 !important;
        }
        @media (max-width: 1280px) {
          .rt-tl-detail-grid {
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;
          }
        }
        .rt-tl-performer-box {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          padding: 8px 10px !important;
          background: linear-gradient(90deg, #ffffff, var(--phase-bg)) !important;
          border: 1px solid rgba(226, 232, 240, 0.95) !important;
          border-radius: 9px !important;
          flex-wrap: wrap !important;
        }
        .rt-tl-performer-avatar {
          width: 30px !important;
          height: 30px !important;
          border-radius: 9px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          background: #ffffff !important;
          border: 1px solid rgba(148, 163, 184, 0.42) !important;
          color: var(--phase-clr) !important;
          font-size: 12px !important;
          font-weight: 850 !important;
          flex-shrink: 0 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.07) !important;
        }
        .rt-tl-performer-info {
          display: flex !important;
          flex-direction: column !important;
          gap: 1px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }
        .rt-tl-performer-name {
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #1e293b !important;
        }
        .rt-tl-performer-email {
          font-size: 11px !important;
          color: #64748b !important;
          font-weight: 500 !important;
        }
        .rt-tl-performer-badge {
          background: #f1f5f9 !important;
          border: 1px solid #e2e8f0 !important;
          padding: 2px 8px !important;
          border-radius: 5px !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          white-space: nowrap !important;
        }
      `}</style>

      <Modal.Header>
        <div className="rt-header-shell">
          <div className="rt-header-top">
            <div className="rt-header-main">
              <i className="rt-header-icon fa fa-history" aria-hidden="true" />
              <div className="rt-header-copy">
                <h2 className="rt-modal-title">
                  <span className="rt-modal-title-text">
                    <span>Task History</span>
                    {task?.wfPhase && (
                      <span className="rt-modal-title-badge">
                        {task.wfPhase}
                      </span>
                    )}
                  </span>
                </h2>
                <div className="rt-modal-meta-row">
                  <span className="rt-meta-chip">
                    <i className="fa fa-tasks" aria-hidden="true" /> Process ID: {task?.ciid || "N/A"}
                  </span>
                  <span className="rt-meta-chip">
                    <i className="fa fa-info-circle" aria-hidden="true" /> Task: {task?.itemName || "N/A"}
                  </span>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="rt-action-btn"
              onClick={handlehistoryAppModalShowHide}
              title="Close"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        {!doneTasks || doneTasks.length === 0 ? (
          <div className="wf-table-empty">
            <div className="wf-te-icon-wrap">
              <div className="wf-te-icon">
                <i className="fa fa-history" aria-hidden="true" />
              </div>
            </div>
            <h3 className="wf-te-title">No Task History</h3>
            <p className="wf-te-desc">There are no completed task history logs for this process yet.</p>
          </div>
        ) : (
          <>
            <div className="rt-history-stats-bar">
              <div className="rt-stat-item">
                <div className="rt-stat-icon">
                  <i className="fa fa-check-circle" aria-hidden="true" />
                </div>
                <div className="rt-stat-info">
                  <span className="rt-stat-label">Completed</span>
                  <span className="rt-stat-value">{sortedDoneTasks.length} Tasks</span>
                </div>
              </div>
              <div className="rt-stat-divider" />
              <div className="rt-stat-item">
                <div className="rt-stat-icon">
                  <i className="fa fa-clock-o" aria-hidden="true" />
                </div>
                <div className="rt-stat-info">
                  <span className="rt-stat-label">First Task</span>
                  <span className="rt-stat-value">
                    <Moment format="MMM D, YYYY">{sortedDoneTasks[0]?.startDateTime}</Moment>
                  </span>
                </div>
              </div>
              <div className="rt-stat-divider" />
              <div className="rt-stat-item">
                <div className="rt-stat-icon">
                  <i className="fa fa-flag-checkered" aria-hidden="true" />
                </div>
                <div className="rt-stat-info">
                  <span className="rt-stat-label">Latest</span>
                  <span className="rt-stat-value">
                    <Moment format="MMM D, YYYY">{sortedDoneTasks[sortedDoneTasks.length - 1]?.endDateTime}</Moment>
                  </span>
                </div>
              </div>
            </div>

            <div className="rt-history-timeline">
              {sortedDoneTasks.map((item, idx) => {
                const phaseClass = getPhaseBadgeColorClass(item.wfPhase);
                const avatarText = (item.performerName || "?").split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
                return (
                  <div key={item.wiid} className="rt-history-timeline-item" style={{ animationDelay: `${idx * 0.06}s` }}>
                    <div className="rt-history-timeline-badge">
                      {idx + 1}
                    </div>
                    <div className={`rt-history-timeline-card ${phaseClass}`}>
                      <div className="rt-tl-card-header">
                        <div className="rt-tl-card-title-row">
                          <span className="rt-tl-title-mark">
                            <i className="fa fa-check" aria-hidden="true" />
                          </span>
                          <div className="rt-tl-card-title-copy">
                            <div className="rt-tl-card-name-row">
                              <span className="rt-tl-card-name">{item.itemName}</span>
                              <span className="rt-tl-card-id">#{item.wiid}</span>
                            </div>
                            <div className="rt-tl-card-subline">
                              <span className="rt-tl-order-chip">Order {getDisplayValue(item.orderNumber)}</span>
                              <span className={`rt-history-phase-badge ${phaseClass}`}>{item.wfPhase}</span>
                            </div>
                          </div>
                        </div>
                        {item.taskDoneDuration && (
                          <span className="rt-tl-card-duration">
                            <i className="fa fa-clock-o" aria-hidden="true" /> {item.taskDoneDuration}
                          </span>
                        )}
                      </div>

                      <div className="rt-tl-card-body">
                        <div className="rt-tl-detail-grid">
                          <div className="rt-tl-detail-item">
                            <span className="rt-tl-detail-icon"><i className="fa fa-cube" aria-hidden="true" /></span>
                            <span className="rt-tl-detail-copy">
                              <span className="rt-tl-detail-label">Item Type</span>
                              <span className="rt-tl-detail-value">{getItemTypeLabel(item.itemType)}</span>
                            </span>
                          </div>
                          <div className="rt-tl-detail-item">
                            <span className="rt-tl-detail-icon"><i className="fa fa-hashtag" aria-hidden="true" /></span>
                            <span className="rt-tl-detail-copy">
                              <span className="rt-tl-detail-label">Item ID</span>
                              <span className="rt-tl-detail-value">{getDisplayValue(item.itemId)}</span>
                            </span>
                          </div>
                          <div className="rt-tl-detail-item">
                            <span className="rt-tl-detail-icon"><i className="fa fa-signal" aria-hidden="true" /></span>
                            <span className="rt-tl-detail-copy">
                              <span className="rt-tl-detail-label">Task State</span>
                              <span className="rt-tl-detail-value">{getTaskStateLabel(item.taskState)}</span>
                            </span>
                          </div>
                          <div className="rt-tl-time-block">
                            <div className="rt-tl-time-icon">
                              <i className="fa fa-play" aria-hidden="true" />
                            </div>
                            <div className="rt-tl-time-info">
                              <span className="rt-tl-time-label">Started</span>
                              <span className="rt-tl-time-val">
                                <Moment format="MMM D, YYYY, h:mm a">{item.startDateTime}</Moment>
                              </span>
                            </div>
                          </div>
                          <div className="rt-tl-time-block">
                            <div className="rt-tl-time-icon">
                              <i className="fa fa-stop" aria-hidden="true" />
                            </div>
                            <div className="rt-tl-time-info">
                              <span className="rt-tl-time-label">Completed</span>
                              <span className="rt-tl-time-val">
                                <Moment format="MMM D, YYYY, h:mm a">{item.endDateTime}</Moment>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="rt-tl-description">
                          <span className="rt-tl-description-icon"><i className="fa fa-align-left" aria-hidden="true" /></span>
                          <span className="rt-tl-description-copy">
                            <span className="rt-tl-description-label">Description</span>
                            <span className="rt-tl-description-value">{getDisplayValue(item.description)}</span>
                          </span>
                        </div>

                        {shouldShowPerformer(item) && (
                          <div className="rt-tl-performer-box">
                            <span className="rt-tl-performer-avatar">{avatarText}</span>
                            <div className="rt-tl-performer-info">
                              <span className="rt-tl-performer-name">
                                {item.performerName || "System"}
                              </span>
                              {item.performerEmail && (
                                <span className="rt-tl-performer-email">
                                  <i className="fa fa-envelope-o" aria-hidden="true" style={{ fontSize: "10px", marginRight: "4px" }} />
                                  {item.performerEmail}
                                </span>
                              )}
                            </div>
                            {(item.performerRole || item.performerDepartment || item.performerPartner) && (
                              <span className="rt-tl-performer-badge">
                                {[item.performerRole, item.performerDepartment, item.performerPartner].filter(Boolean).join(" · ")}
                              </span>
                            )}
                          </div>
                        )}

                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="wf-modal-footer-close-btn"
          onClick={handlehistoryAppModalShowHide}
        >
          <i className="fa fa-times" aria-hidden="true" /> Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TaskHistory;
